import React from 'react';
import { Card } from '../ui/Card';
import { ZapIcon, EyeIcon, DatabaseIcon, GitForkIcon, FileTextIcon, SearchIcon } from 'lucide-react';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
function FeatureCard({
  icon,
  title,
  description
}: FeatureCardProps) {
  return <Card hover className="group">
      <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
        <div className="text-primary-400">{icon}</div>
      </div>
      <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed">{description}</p>
    </Card>;
}
export function FeaturesGrid() {
  const features = [{
    icon: <ZapIcon className="w-6 h-6" />,
    title: 'Eager Execution',
    description: 'Work progresses automatically. Tasks start as soon as their dependencies are met—no manual triggering required.'
  }, {
    icon: <EyeIcon className="w-6 h-6" />,
    title: 'Attention Set',
    description: 'Only get interrupted when it matters. The system handles routine work and surfaces what truly needs your input.'
  }, {
    icon: <DatabaseIcon className="w-6 h-6" />,
    title: 'Context Stores',
    description: 'Persistent memory per stream. Agents remember decisions, artifacts, and learnings across all tasks.'
  }, {
    icon: <GitForkIcon className="w-6 h-6" />,
    title: 'Branch & Pivot',
    description: 'Explore alternatives safely. Create branches to test different approaches without losing your main path.'
  }, {
    icon: <FileTextIcon className="w-6 h-6" />,
    title: 'Self-Documenting',
    description: 'Reports generate themselves. Every decision, approach, and outcome is captured and exportable.'
  }, {
    icon: <SearchIcon className="w-6 h-6" />,
    title: 'Org-Wide Search',
    description: 'Find who knows what. Search across all streams to discover expertise and avoid duplicate work.'
  }];
  return <section className="py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-primary-400 font-medium mb-4">Features</p>
          <h2 className="text-4xl font-bold text-white mb-6">
            Everything you need to work smarter
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Built for teams who want to move fast without losing context.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => <FeatureCard key={index} {...feature} />)}
        </div>
      </div>
    </section>;
}